import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import WhatsAppButton from '@/components/feature/WhatsAppButton';
import ServicesCarousel from './components/ServicesCarousel';
import ServicesPreview from './components/ServicesPreview';
import WhyUs from './components/WhyUs';
import CTABanner from './components/CTABanner';

const schemaData = {
  '@context': 'https://schema.org',
  '@type': 'LocalBusiness',
  name: 'JampaBit Informática',
  description: 'Suporte técnico em TI em João Pessoa: formatação, montagem de PCs gamers, limpeza, suporte remoto, instalação de softwares e consultoria em TI.',
  url: import.meta.env.VITE_SITE_URL,
  telephone: '+55-83-99175-5663',
  email: 'jampabit@gmail.com',
  address: {
    '@type': 'PostalAddress',
    addressLocality: 'João Pessoa',
    addressRegion: 'PB',
    addressCountry: 'BR',
  },
  geo: {
    '@type': 'GeoCoordinates',
    latitude: -7.1195,
    longitude: -34.9286,
  },
  openingHoursSpecification: [
    {
      '@type': 'OpeningHoursSpecification',
      dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
      opens: '08:00',
      closes: '18:00',
    },
    {
      '@type': 'OpeningHoursSpecification',
      dayOfWeek: ['Saturday'],
      opens: '08:00',
      closes: '13:00',
    },
  ],
  sameAs: ['https://wa.me/5583991755663'],
  priceRange: '$$',
  areaServed: {
    '@type': 'City',
    name: 'João Pessoa',
  },
  hasOfferCatalog: {
    '@type': 'OfferCatalog',
    name: 'Serviços de Informática',
    itemListElement: [
      { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Formatação de Micros e Notebooks' } },
      { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Montagem de Computadores Gamers' } },
      { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Limpeza e Manutenção' } },
      { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Suporte Remoto' } },
      { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Instalação de Softwares' } },
      { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Consultoria em TI' } },
      { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Criação de Sites Personalizados' } },
    ],
  },
  aggregateRating: {
    '@type': 'AggregateRating',
    ratingValue: '5',
    reviewCount: '500',
  },
};

export default function HomePage() {
  useEffect(() => {
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.id = 'schema-home';
    script.textContent = JSON.stringify(schemaData);
    document.head.appendChild(script);
    return () => {
      const el = document.getElementById('schema-home');
      if (el) el.remove();
    };
  }, []);

  return (
    <div className="min-h-screen">
      <Navbar />
      <main>
        <ServicesCarousel hero />
        <ServicesPreview />
        <WhyUs />
        <CTABanner />
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
}
